module.exports = __webpack_public_path__ + "static/img/hotRdetail.db4415c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hotpic/hotRdetail.jpg
// module id = VfQ/
// module chunks = 51